export const palette = {
  bg: `var(--rds-bg)`,
  bgDeep: `var(--rds-bg-deep)`,
  bgCard: `var(--rds-bg-card)`,
  plum: `var(--rds-plum)`,
  cream: `var(--rds-cream)`,
  creamDim: `var(--rds-cream-dim)`,
  gold: `var(--rds-gold)`,
  goldBright: `var(--rds-gold-bright)`,
  goldFirst: `var(--rds-gold-first)`,
  inputBg: `var(--rds-input-bg)`,
  inputBorder: `var(--rds-input-border)`,
  inputPlaceholder: `var(--rds-input-placeholder)`,
  textOnGold: `var(--rds-text-on-gold)`,
};

export const serifItalic = `var(--rds-serif)`;
